wbApp.controller('LeadsSelectOpenLeadsDialogCtrl', ['$scope', '$modal', '$translate', '$q', '$filter',   
function ($scope, $modal, $translate, $q, $filter) {


    $scope.onLeadSelectionDetailSave = function (model) {
        $scope.onLeadSelected($scope.selectedLead);
        $scope.$hide();
    }

    $scope.onLeadSelectionDetailCancel = function () {
        $scope.onLeadSelected(null);
        $scope.$hide();
    }

    $scope.onLeadSelectionRowSelected = function (row) {
        $scope.selectedLead = row;
    }

    $scope.canBeSaved = function () {
        return !!$scope.selectedLead;
    }

    $scope.leadSelectionGridSettings = {
        name: 'leadSelection',
        keyExpr: 'id',
        columns: [
            {
                dataField: 'id',
                caption: $translate.instant('TXT_LBL_ID'),
                dataType: 'string',
                visible: false,
                showInColumnChooser: false
            },
            {
                dataField: 'createdAtUtc',
                caption: $translate.instant('TXT_LBL_CREATED_AT'),
                dataType: 'date',
                format: { type: 'shortDateShortTime' },
                width: '140px',
                sortOrder: 'desc',
                calculateCellValue: function (rowData) {
                    if (rowData.auditEvents && rowData.auditEvents.length != 0) {
                        return rowData.auditEvents[0].eventTimeUtc;
                    }
                    return '';
                },
            },
            {
                dataField: 'leadSourceType',
                caption: $translate.instant('TXT_CONSENT_TYPE'),
                dataType: 'string',
                lookup: {
                    allowClearing: true,
                    dataSource: {
                        store: {
                            type: 'array',
                            data: [
                                { id: 0, name: $translate.instant('TXT_LEAD_SOURCE_FORM_RESPONSE') },
                                { id: 1, name: $translate.instant('TXT_LEAD_SOURCE_FULL_COURSE_INTEREST') },
                                { id: 2, name: $translate.instant('TXT_LEAD_SOURCE_PHONE') },
                                { id: 3, name: $translate.instant('TXT_LEAD_SOURCE_EMAIL') },
                                { id: 4, name: $translate.instant('TXT_LEAD_SOURCE_PERSONAL_CONTACT') },
                                { id: 5, name: $translate.instant('TXT_LEAD_SOURCE_COURSE_INTEREST') }
                            ],
                            key: "id"
                        },
                        pageSize: 10,
                        paginate: false
                    },
                    valueExpr: 'id', // contains the same values as the "statusId" field provides
                    displayExpr: 'name' // provides display values
                },
                width: '70px'
            },
            {
                dataField: 'leadSourceName', caption: $translate.instant('TXT_NAME'),
                dataType: 'string',
                width: '120px'
            },
            {
                dataField: 'leadSourceText', caption: $translate.instant('TXT_LBL_TEXT'),
                dataType: 'string'
            }
        ]
    };
}]);
